var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Upload',{attrs:{"type":"drag","action":_vm.baseUrl + 'api/services/app/UploadFile/Upload',"on-success":_vm.handleUploadSuccess,"headers":_vm.headers,"accept":".xlsx"}},[_c('div',{staticStyle:{"padding":"20px 0"}},[_c('Icon',{staticStyle:{"color":"#3399ff"},attrs:{"type":"ios-cloud-upload","size":"52"}}),_c('p',[_vm._v("点击选择文件或将文件拖拽到此处完成导入")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71be7964","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/user/import.vue
// module id = null
// module chunks = 